/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export const HuntingPermitProps = PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
});

export const SeasonProps = PropTypes.shape({
    id: PropTypes.string,
    year: PropTypes.number,
});
